import { render } from "./SimpleBox.vue?vue&type=template&id=7643ff17"
import script from "./SimpleBox.vue?vue&type=script&lang=js"
export * from "./SimpleBox.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SimpleBox.vue?vue&type=style&index=0&id=7643ff17&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__